import * as yup from "yup"
import config from "../config"

const encodeUrlComponentStrict = (value: string): string =>
    encodeURIComponent(value).replace(
        /[!'()*]/g,
        (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`
    )

export const wrapUrlForProxy = (
    targetUrl: string,
    type: "text" | "image" | "font" = "text"
): string => {
    const ENDPOINT = "/proxy"
    const PROXY_BASE_URL = `${config.url}${ENDPOINT}`

    if (!targetUrl) {
        return targetUrl
    }

    // check if targetUrl already have PROXY_BASE_URL prefix
    if (targetUrl.toUpperCase().startsWith(PROXY_BASE_URL.toUpperCase())) {
        console.warn(`URL is already proxied: ${targetUrl}. Returning original.`)
        return targetUrl
    }

    // add PROXY_BASE_URL prefix
    return `${PROXY_BASE_URL}?url=${encodeUrlComponentStrict(targetUrl)}`
}

export const isValidUrlOrProxy = (value?: string) => {
    if (!value) return false
    try {
        const parsed = new URL(value)
        if (parsed.pathname.toLowerCase().endsWith("/proxy")) {
            const inner = parsed.searchParams.get("url")
            if (!inner) return false
            let decoded = inner
            try {
                decoded = decodeURIComponent(inner)
            } catch {
                decoded = inner
            }
            return yup.string().url().isValidSync(decoded)
        }
    } catch {
        return yup.string().url().isValidSync(value)
    }

    return yup.string().url().isValidSync(value)
}
